export const PAGE_SECTION_KINDS = {
    BLOCK: "block",
    TOOL: "tool",
};

export const PAGE_SECTION_TYPES = {
    BLOCK: "block",
    COFFEE: "coffee",
    COOKIE: "cookie",
    FAQ: "faq",
    LEGAL: "legal",
    LOVE: "love",
    PRICING: "pricing",
    TICKER: "ticker",
};
